module.exports = __webpack_public_path__ + "a5080d9e55b71a50ecd7b7d7ad022754.ttf";